var r=function(r,t){return r/t};export{r as default};
